export default __webpack_public_path__ + "static/media/Mapa-procesos.ed37b48f.jpg";